import React, { useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { downloadPoster, POSTER_SIZES, POSTER_TEMPLATES } from "@/lib/posterExport";

/** Instagram-ready poster export — pick a look, then a size. */
export default function PosterDownload({ event, className = "", label = "Poster", testId = "poster-download" }) {
  const [open, setOpen] = useState(false);
  const [tpl, setTpl] = useState("prism");
  const [busy, setBusy] = useState("");

  const grab = async (key) => {
    setBusy(key);
    try {
      await downloadPoster(event, key, tpl);
      toast.success("Poster downloaded — post it to your Instagram");
      setOpen(false);
    } catch {
      toast.error("Could not generate the poster");
    } finally {
      setBusy("");
    }
  };

  return (
    <div className="relative inline-block">
      <button type="button" onClick={() => setOpen((o) => !o)} data-testid={testId}
        className={className || "btn-ghost !py-1.5 !px-3 !text-xs"}>
        <Download className="w-3.5 h-3.5" /> {label}
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-[80]" onClick={() => setOpen(false)} />
          <div className="absolute z-[81] bottom-full mb-2 left-0 w-72 p-3 glass !rounded-2xl shadow-2xl"
            data-testid={`${testId}-menu`}>
            <div className="pb-2 text-[10px] font-mono uppercase tracking-[0.18em] text-lime">Pick a look</div>
            <div className="grid grid-cols-3 gap-1.5">
              {Object.entries(POSTER_TEMPLATES).map(([key, t]) => (
                <button key={key} type="button" onClick={() => setTpl(key)} data-testid={`${testId}-tpl-${key}`}
                  className={`px-2 py-2 rounded-xl text-[11px] font-heading font-bold transition-colors ${tpl === key ? "bg-lime text-ink" : "bg-white/5 text-white/80 hover:bg-white/10"}`}>
                  {t.label}
                </button>
              ))}
            </div>
            <div className="mt-1.5 text-[10px] text-muted">{POSTER_TEMPLATES[tpl]?.note}</div>
            <div className="mt-3 pt-2 border-t border-white/10 text-[10px] font-mono uppercase tracking-[0.18em] text-white/45">Download</div>
            {Object.entries(POSTER_SIZES).map(([key, s]) => (
              <button key={key} type="button" onClick={() => grab(key)} disabled={!!busy}
                data-testid={`${testId}-${key}`}
                className="w-full mt-1.5 text-left px-3 py-2.5 rounded-xl text-xs font-body text-white/85 bg-white/5 hover:bg-white/12 hover:text-white transition-colors flex items-center justify-between gap-2 disabled:opacity-50">
                <span>{s.label}</span>
                {busy === key ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <span className="text-[10px] font-mono text-white/45">{s.note}</span>}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
